export default __webpack_public_path__ + "static/media/Group (1).ddf97980.svg";